"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/tag/v1/admin_service.proto (package spwn.tag.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminTagService = void 0;
const admin_service_pb_1 = require("./admin_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.tag.v1.AdminTagService
 */
exports.AdminTagService = {
    typeName: "spwn.tag.v1.AdminTagService",
    methods: {
        /**
         * ブランドのタグリスト取得
         *
         * @generated from rpc spwn.tag.v1.AdminTagService.GetTags
         */
        getTags: {
            name: "GetTags",
            I: admin_service_pb_1.AdminTagServiceGetTagsRequest,
            O: admin_service_pb_1.AdminTagServiceGetTagsResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * 指定タグIDでタグ取得
         *
         * @generated from rpc spwn.tag.v1.AdminTagService.GetTagById
         */
        getTagById: {
            name: "GetTagById",
            I: admin_service_pb_1.AdminTagServiceGetTagByIdRequest,
            O: admin_service_pb_1.AdminTagServiceGetTagByIdResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * タグ追加
         *
         * @generated from rpc spwn.tag.v1.AdminTagService.AddTag
         */
        addTag: {
            name: "AddTag",
            I: admin_service_pb_1.AdminTagServiceAddTagRequest,
            O: admin_service_pb_1.AdminTagServiceAddTagResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * タグ編集
         *
         * @generated from rpc spwn.tag.v1.AdminTagService.UpdateTag
         */
        updateTag: {
            name: "UpdateTag",
            I: admin_service_pb_1.AdminTagServiceUpdateTagRequest,
            O: admin_service_pb_1.AdminTagServiceUpdateTagResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * タグ削除
         *
         * @generated from rpc spwn.tag.v1.AdminTagService.DeleteTag
         */
        deleteTag: {
            name: "DeleteTag",
            I: admin_service_pb_1.AdminTagServiceDeleteTagRequest,
            O: admin_service_pb_1.AdminTagServiceDeleteTagResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 複数グッズに対して指定1タグを追加
         *
         * @generated from rpc spwn.tag.v1.AdminTagService.AddTagToGoods
         */
        addTagToGoods: {
            name: "AddTagToGoods",
            I: admin_service_pb_1.AdminTagServiceAddTagToGoodsRequest,
            O: admin_service_pb_1.AdminTagServiceAddTagToGoodsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 複数グッズから指定1タグを削除
         *
         * @generated from rpc spwn.tag.v1.AdminTagService.RemoveTagFromGoods
         */
        removeTagFromGoods: {
            name: "RemoveTagFromGoods",
            I: admin_service_pb_1.AdminTagServiceRemoveTagFromGoodsRequest,
            O: admin_service_pb_1.AdminTagServiceRemoveTagFromGoodsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=admin_service_connect.js.map